import { render, staticRenderFns } from "./modal-instructions.vue?vue&type=template&id=6d85bb1b&scoped=true"
import script from "./modal-instructions.vue?vue&type=script&lang=js"
export * from "./modal-instructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d85bb1b",
  null
  
)

export default component.exports